import BaseRequest from "./BaseRequest";
import SingletonBootConfig from "./SingletonBootConfig";

export default class LoginRequest {
  static CreateSession = async (userName, domain) => {
    let path = SingletonBootConfig.getInstance().getChatWS() + "/requestAgent";
    return await BaseRequest.GetXMLRequest(path, {
      username: userName,
      idClient: 1,
      domain: domain ? domain : window["boot"].domain
    });
  };

  static CreateChat = async session => {
    console.log("CREATING CHAT");
    let path = SingletonBootConfig.getInstance().getExternalChat();
    return await BaseRequest.GetXMLRequest(path, {
      process: 1,
      random: Math.floor(Math.random() * 1000 + 1),
      session: session
    });
  };

  static Abandoned = async session => {
    let path = SingletonBootConfig.getInstance().getExternalChat();
    return await BaseRequest.GetXMLRequest(path, {
      process: 3,
      abandoned: 0,
      random: Math.floor(Math.random() * 1000 + 1),
      session: session
    });
  };

  static AbandonedSync = session => {
    let path = SingletonBootConfig.getInstance().getExternalChat();
    path = path.concat(
      "?process=",
      "3",
      "&abandoned=",
      "0",
      "&random=",
      Math.floor(Math.random() * 1000 + 1),
      "&session=",
      session
    );
    let client = new XMLHttpRequest();
    client.open("GET", path, false);
    client.send();
  };
}
